import React, { useEffect, useState } from 'react';
import {connect, dispatch} from 'react-redux'

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios, {source} from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'
import {authHeaders} from '../../../helpers'

import { SimpleAccountsTable } from '../../Account';
import { CircularProgress, Backdrop, Card, CardHeader, CardContent, Divider, Grid, Typography, Avatar, CardActions, Button } from '@mui/material';
import { NumericFormat } from 'react-number-format'
import useClasses from '../../../helpers/useClasses';
import { Girl } from '@mui/icons-material';
import moment from 'moment';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const SearchHistoryCorrelation = props => {
  const classes = useClasses(styles);

  const [loading, setLoading] = useState(true)
  const [correlations, setCorrelations] = useState([])

  const handleSearchCorrelationDescriptionClick = (event) => {
    document.getElementById("searchCorrelationDescription").style.display = 'block'
  };
  
  useEffect(() => {
    setLoading(true)
    let url = `/widgets/search_correlations`
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        const fetchedCorrelations = []
        for(let key in response.data.data){
          fetchedCorrelations.push({
            ...response.data.data[key],
            id: key
          })
        }

        setLoading(false)
        setCorrelations(fetchedCorrelations.sort((a, b) => a.sort - b.sort))
      }
      else {
        setLoading(false)
      }
    })
    .catch(error => {
      setLoading(false)
    })
    
    return () => {
      source.cancel()
    }
  }, [])

  
  let correlationsDisplay = (
    <CircularProgress color="inherit" />
  )
  if(!loading){
    correlationsDisplay = (
      <React.Fragment>
        <Grid
          container
          justifyContent="space-around"
          spacing={4}
        >
          {correlations.map(correlation => (
            <Grid size={{xs:12, sm:6, lg: 4, xl:2}}>
              <Card key={correlation.id} sx={{
                      margin: '20px'
                    }}>
                <CardHeader title={`${correlation.tier} searches`} sx={{
                      textAlign: 'center',
                      backgroundColor: '#ddd'
                    }}>
                  {/* <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                    align="center"
                  >
                    {correlation.tier} searches
                  </Typography> */}
                </CardHeader>
                <Divider></Divider>
                <CardContent>
                  <Grid
                    container
                  >
                    <Grid size={{xs:12, xl:12}}>
                      <Typography variant="h3" align="center">{Math.round(correlation.pct)}%</Typography>
                    </Grid>
                    <Grid size={{xs:12, xl:12}}>
                      <Typography variant="subtitle2" align="center" sx={{ textAlign:"center"}}>now in DataMerch</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </React.Fragment>
    )
  }
  
  return (
    <Card>
      <CardHeader
        title={`Search History Correlation`}
        subheader={`Calculated on ${correlations.length ? moment(correlations[0].dt, 'YYYY-MM-DD').format('MM/DD/YYYY') + ' based on searches between ' + moment(correlations[0].dt, 'YYYY-MM-DD').subtract(1, 'year').format('MM/DD/YYYY') + ' and ' + moment(correlations[0].dt, 'YYYY-MM-DD').subtract(6, 'months').format('MM/DD/YYYY') : ''}`}
      />
      <Divider />
      {correlationsDisplay}
      <Divider />
      <CardActions>
        <Grid
          container
        >
          <Grid>
            <Button onClick={handleSearchCorrelationDescriptionClick} size="small">What is this and how is it calculated?</Button>
          </Grid>
          <Grid id="searchCorrelationDescription" sx={{display: 'none'}}>
            <Typography variant="subtitle1" sx={{padding: '10px'}}>
              Search correlation is calculated by looking back 1 year and 6 months ago. We take a data set of unique EIN searches (counted only once per funder - no duplicate searches) that did NOT result in a DataMerch hit. We then compare that data set to how many of those same EINs now exist in DataMerch. The 6-month period above indicates how many times the EINs that now have existing records were uniquely searched.
            </Typography>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default withErrorHandler(SearchHistoryCorrelation, axios)